module.exports = __webpack_public_path__ + "assets/img/car.0d5ae7e2.png";